const logger = {
    save(error) {
        console.warn(error);
    }
}
export default logger;